import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AbstractControl, FormControl, FormGroup } from "@angular/forms";
import { TriggerSeverity } from "@app2/clients/types/alert-typedefs";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

// Severities for tickets, threats, etc.
export const severities = Object.freeze([
    { key: "NONE", value: "NONE" },
    { key: "LOW", value: "LOW" },
    { key: "MEDIUM", value: "MEDIUM" },
    { key: "HIGH", value: "HIGH" },
]);

// Severities for triggers
export const triggerSeverities = Object.freeze([
    { key: "INFORMATIONAL", value: "INFORMATIONAL" },
    { key: "LOW", value: "LOW" },
    { key: "MEDIUM", value: "MEDIUM" },
    { key: "HIGH", value: "HIGH" },
    { key: "TEST", value: "TEST" },
]);

@UntilDestroy()
@Component({
    selector: "severity-edit",
    template: `
        <form [formGroup]="editForm"
              *ngIf="severity">
            <ds-select [control]="editForm.get('newSeverity')"
                       [options]="allSeverities"
                       test-id="new-severity">
            </ds-select>
        </form>
    `,
})
export class SeverityEditComponent implements OnInit {
    @Input() severity: string;
    @Input() isTrigger: boolean = false;

    @Output() severityChange = new EventEmitter<TriggerSeverity>();
    @Output() formValidityChange = new EventEmitter<boolean>();

    allSeverities: Readonly<Array<{ key: string, value: string }>>;
    editForm = new FormGroup({
            newSeverity: new FormControl("")
        }
    );

    ngOnInit() {
        this.allSeverities = this.isTrigger ? triggerSeverities : severities;
        this.editForm.validator = (control: AbstractControl) => {
            if (!this.allSeverities?.map(kv => kv.key).includes(control.value.newSeverity)) {
                return { "INVALID_OPTION": control.value };
            }
        };
        this.editForm.validator = (control: AbstractControl) => {
            if (!this.allSeverities?.map(kv => kv.key).includes(control.value.newSeverity)) {
                return { "INVALID_OPTION": control.value };
            }
        };
        this.editForm.statusChanges
            .pipe(untilDestroyed(this))
            .subscribe(status => this.formValidityChange.emit(status === "VALID"));

        this.editForm.get("newSeverity").valueChanges
            .pipe(untilDestroyed(this))
            .subscribe(value => this.severityChange.emit(<TriggerSeverity>value));
        if (this.severity) {
            this.editForm.get("newSeverity")!.setValue(this.severity);
        }
    }

    public getNewSeverity(): string {
        return this.editForm.get("newSeverity")!.value;
    }
}
